import React, { Component } from 'react'
import ExtraFooterMenuContainer from './ExtraFooterMenu'
// import ExtraFooterMenu from './ExtraFooterMenu'
import Footer from './Footer'

class SiteFooter extends Component {
    constructor(props) {
        super(props)

        this.state = {
            siteHeaderData: {},
            topMenuData: {},
            socialmediaData: {},
            bottomMenuData: {},
            cinemaData: {}
        }
    }

    componentDidMount() {
        this.setState({
            siteHeaderData: pmkinoFrontVars.siteHeaderData,
            topMenuData: pmkinoFrontVars.topMenuData,
            socialmediaData: pmkinoFrontVars.cinemaData.socialmedia,
            bottomMenuData: pmkinoFrontVars.bottomMenuData,
            extraBottomMenuData: pmkinoFrontVars.extraBottomMenuData,
            cinemaData: pmkinoFrontVars.cinemaData
        })
    }

    render() {
        const { siteHeaderData, socialmediaData, bottomMenuData, extraBottomMenuData, cinemaData } = this.state

        const classFooterExtra = extraBottomMenuData ? 'has-extramenu' : 'has-no-extramenu'

        return (
            <div className={"footer-wrapper " + classFooterExtra}>
                <ExtraFooterMenuContainer
                    key="extra-footer-menu"
                    extraBottomMenuData={extraBottomMenuData}
                />
                <Footer 
                    key="footer"
                    siteHeaderData={siteHeaderData}
                    cinemaData={cinemaData}
                    socialmediaData={socialmediaData}
                />
            </div>
        )
    }
}

export default SiteFooter